<template>
    <d2-container>
        <div  class="divWH">
            <img class="imageWH" src="./image/image1.png"  />
            <div class="bottomText">
                <div class="buttonBox1">
                    <div class="buttonBox">
                        <div>
                            我支持我传递
                        </div>
                        <div class="btnTip">
                            已有2758人传递，快来加入吧！
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </d2-container>
</template>
<script>
import mathUtil from '../../utils/mathUtil'
export default {
    index: 15,
    data() {
        return {
            image: 'image1',
            imageNumber: 0,
            imageNumber2: 0,
            openId: this.$route.query.openId,
            ruonerText: '“传承文明祭祀，共建绿色家园”',
            ruoner: {
                image1: '“传承文明祭祀，共建绿色家园”',
                image2: '云端寄哀思，文明传真情',
                image3: '鲜花换纸钱，文明寄思念',
                image4: '绿色清明 低碳追思',
                image5: '清明祭先祖，文明伴新风',
                image6: '清明寄思语，文明润人心',
                image7: '摒弃烟火气，传承感恩心',
                image8: '春风传心意，云端寄追思',
                image9: '摒弃旧俗陋习，崇尚文明祭扫',
                image10: '文明祭扫践于行，生态清明始于心',
                image11: '文明新风拂清明，生态家园共守护'
            }
        }
    },
    methods: {
        leftImageFun() {
            let images = this.image.split('image')
            let numberS = mathUtil.accSub(images[1], 1)
            this.image = 'image' + numberS
            this.ruonerText = this.ruoner[this.image]
        },
        rigthImageFun() {
            let images = this.image.split('image')
            let numberS = mathUtil.accAdd(images[1], 1)
            this.image = 'image' + numberS
            this.ruonerText = this.ruoner[this.image]
        }
    },
    mounted() {
        if (this.$route.query.image) {
            this.image = this.$route.query.image
        }
    }
}
</script>
<style lang="scss" scoped>
@font-face {
    font-family: 'huangkaihuaLawyerfont';
    src: url('https://wjtr-mall.oss-cn-beijing.aliyuncs.com/ttmy/zitidi.com.ttf');
}

.divWH {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    position: relative;

    .imageWH {
        width: 100%;
        height: 100%;
    }

    .bottomText {
        position: absolute;
        bottom: 112px;
        z-index: 9;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-content: center;
    }

    .textTip {
        padding: 0px 12px;
        font-family: huangkaihuaLawyerfont;
        font-weight: 400;
        font-size: 18px;
        color: #000000;
        text-align: center;
        font-style: normal;
        text-transform: none;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .textTipBottom {
            margin-top: 12px;

            span {
                font-size: 22px;
            }
        }
    }
    .buttonBox1 {
        margin: 0px 12px;
        margin-top: 23px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .buttonBox {
        padding: 0px 10px;
        min-width: 258px;
        min-height: 60px;
        background: rgba(0, 0, 0, 0.8);
        border-radius: 40px 40px 40px 40px;
        border: 1px solid #ffffff;
        box-sizing: border-box;
        display: inline-flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        line-height: 1;
        vertical-align: middle;
        white-space: nowrap;
        font-family: huangkaihuaLawyerfont, huangkaihuaLawyerfont;
        font-weight: 400;
        font-size: 18px;
        color: #ffffff;
        .btnTip {
            margin-top: 8px;
            font-weight: 400;
            font-size: 12px;
            color: #ffffff;
        }
    }
}
</style>
